import { render, staticRenderFns } from "./Comparator.vue?vue&type=template&id=e1a90cdc&"
import script from "./Comparator.vue?vue&type=script&lang=js&"
export * from "./Comparator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports